export default "__VITE_ASSET__$X8sdwuY__"